export const getDisplayName = (wc) => wc.displayName || wc.name || 'Component';
